import { Input, Output, ViewChild, EventEmitter, HostListener, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormArray, FormsModule } from '@angular/forms';
import { WebRequestService } from 'src/app/services/web-request.service';
import { LoaderComponent } from '../../builders/loader/loader.component';
import { Data } from 'src/app/helper/datastore';
import { MatTableDataSource } from '@angular/material/table';
import { EditViewSlideShowComponent } from '../edit-view-slide-show/edit-view-slide-show.component';
import { MatDialog } from '@angular/material/dialog';
import { BrokerCreateDialogComponent } from 'src/app/modules/admin-forms/broker-create-dialog/broker-create-dialog.component';
import { CustomerLeftUpdateDialogComponent } from 'src/app/modules/dashboard/customer-left-update-dialog/customer-left-update-dialog.component';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { FormatHistoryComponent } from 'src/app/modules/communicationlog/format-history/format-history.component';
import { OldSlideShowComponent } from 'src/app/modules/matchfollowup/old-slide-show/old-slide-show.component';
import { ReasonDialogComponent } from 'src/app/modules/view-profile/reason-dialog/reason-dialog.component';

import { from } from 'rxjs';

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})
export class GridComponent implements OnInit, AfterViewInit {
  LoaderComponent: any;
  showPopup: boolean = false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('exporter') exported: any;
  @ViewChild('hiddenExporter') hidddenExported: any;
  @ViewChild('table', { static: false }) table: any;
  @ViewChild('descriptionModal') descriptionModal: any;
  @ViewChild('adminModal') adminModal: any;
  @ViewChild('successModal') successModal: any;
  @ViewChild('confirmModal') confirmModal: any;
  @ViewChild('updatePointsModal') updatePointsModal: any;
  @ViewChild('brokerConfirmModal') brokerModal: any;
  @ViewChild('expressModal') public expressModal;
  @ViewChild('alertModal')
  alertModal: any;
  @ViewChild('warningModal')
  warningModal: any;
  @ViewChild('reasonModal')
  excelModal: any;
  @HostListener('scroll', ['$event'])
  @Input()data2:any=[];
  @Input()defaultColumns2:any =[];
  @Input() matchedHeaders2:any =[]
  @Input() data: any[];
  @Input() myProfileReqObj : any[];
  @Input() printAddress: any;
  @Input() printAdvAddress: any;
  @Input() displayedColumns: any = [];
  @Input() multiSelectItems: any = [];
  @Input() defaultColumns: any = [];
  @Input() selectedItems: any = [];
  @Input() profileCounts: any;
  @Input() totalRows: any;
  @Input() itemsPerPage: any;
  @Input() formValue: any;
  @Input() matchedHeaders: any;
  @Input() type: any;
  @Input() type1: any;
  @Input() search: any;
  @Input() dataToGrid: any;
  @Input() grid2Type: any;
  @Input() grid2:any;
  @Input() profileTypeArray: any = [];
  @Input() loginData: any;
  @Input() slideForm:any;
  @Input() mmSeriousDialogEnable: boolean;
  @Input() searchGridMargin: boolean;
  @Input() communicationLog: boolean;
  @Input() scrollDown: boolean;
  @Input() searchSub: boolean;
  @Input() autoMailGrid: boolean;
  @Input() suitableEveObj;
  @Input() myProfile;
  @Input() myProfileGrid;
  @Input() myProfiles;
  @Input() reqObj;
  @Input() display;

  @Output() navigateBack = new EventEmitter();
  @Output() expressData = new EventEmitter();
  @Output() submitGridData = new EventEmitter();
  @Output() pageEvent = new EventEmitter();
  @Output() enableSAForm = new EventEmitter();
  @Output() renewalEvent = new EventEmitter();
  @Output() assignedOwner = new EventEmitter();
  @Output() updateReAssignData = new EventEmitter();
  @Output() findDuplicateProfiles = new EventEmitter();
  @Output() selectedStatusType = new EventEmitter();
  @Output() selectedSecondOwner = new EventEmitter();
  @Output() selectedOwner = new EventEmitter();
  @Output() openPlayButtonMode  = new EventEmitter();
  @Output() playRecording  = new EventEmitter();

  @Output() playSlider = new EventEmitter();
  @Output() openMatchFollowupTicket = new EventEmitter();
  @Output() resendComMail = new EventEmitter();
  @Output() authorize = new EventEmitter();
  @Output() updateActions = new EventEmitter();
  @Output() updatePointsTable = new EventEmitter();
  @Output() createTkt = new EventEmitter();
  @Output() loadBrokerList = new EventEmitter();
  @Output() reloadCustomersList = new EventEmitter();
  brokerDetail: any;
  setDefaultProfileOwner: boolean;
  playSlide : boolean = false;
  dummy:any;
  selectedProfileType: any = "";
  isSAEnabled: any = false;
  SAAmount: any = "";
  descriptionMessage: any = "";
  adminForm: FormGroup;
  excelForm: FormGroup;
  paymentExpiryDate:any;
  updatePointsForm: FormGroup;
  defaultProfileCount = 0
  length = 100;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  manualPage = null;
  pageIndex: number;
  dataSource: any
  multiDropdownSettings: any = {};
  exportRecordsErrMsg : string = "";
  myProfileExportData : any = [];
  // modal logic definations
  modalBoolean: any = false;
  ticketId: any;
  assignOwnerForm: FormGroup;
  dataFormArray: FormArray;
  profileOwnerArray: any = [];
  responseMessage: any = "";
  dropDownSettings: any = {};
  dropDownSettings2: any = {};
  dummyRadioValue:any;
  paymentType:any="";
  payment = {paymentType:""};
  PayPal:any;
  Credit:any;
  saFormPhotoPath:any;
  balanceAmount:any;
  isGreaterAmount:boolean = false;
  isValidAmount:boolean = false;
  slideShowForm:any;
  isPlaySideShow:boolean = false;
  mode:any;
  isUpdatedPointsValue:boolean = false;
  adminProfileId:any;
  isDisplayNone : boolean = false;

  empNameMultiSelectItems: any =[];
  logeedInUser: any[];
  assignProfileOwner: FormGroup;
  selectedOwnerId: any;
  checkedProfileId: any[] = [];
  isProfileChecked: boolean = false;
  addedProfilesList: any[] = [];
  addtoPriorityProfilesList: any[] = [];
  branchUpdateMode: boolean = false;
  reactivateProfileID:any;
  showCallRecordings: any;
  marketingFormatAccess:any;
  redirectToViewProfile:any;
  allSelectedProfiles: any[] = [];
  sendFromProfileIDs: any[] = [];
  showExpressIntrest: boolean = false;
  isConfidentialShorlist: boolean = false;
  fromProfileIdData: any;
  toProfileIdData:any;
  alertMessage: any = [];
  toProfileIDAllData:any;
  removeChecked:boolean=false;
  dataToPrint: any[] = [];
  finalDataToPrint: any;
  fromValue: any;
  toValue: any;
  difference: any;
  exportForm: FormGroup;
  errorMessage: any;
  invalidDifference: any;
  excelFormSubmitted: boolean = false;
  matchingProfileOwner: any;
  matchingSecondaryOwner: any;
  constructor(private loginDataStore: Data, private router: Router, public service: WebRequestService, private dialog1: MatDialog,
    public dialog: MatDialog, public utilitiesService: UtilitiesService, private cdr : ChangeDetectorRef) {
    this.multiDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
      itemsShowLimit: 3,
      enableCheckAll: false,
    };

    this.dropDownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
    };
    this.dropDownSettings2 = {
      singleSelection: true,
      idField: 'id',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
    };
  }
  selectedProfileColor:any;
  selectedIndex:any
  onScrollingFinished() {
  }
  ngOnInit(): void {
    // if (this.data.length > 50) {
    //   var elmnt = document.getElementById("default-content");
    // console.log(elmnt.scrollTop)
    // }
    this.excelForm = new FormGroup({
      fromValue: new FormControl("",[Validators.required]),
      toValue: new FormControl("",[Validators.required])
    })

    this.adminForm = new FormGroup({
      agreedAmount: new FormControl("", [Validators.required]),
      paidAmount: new FormControl("", [Validators.required]),
      paydescription: new FormControl("", [Validators.required])
    })
    this.updatePointsForm = new FormGroup({
      extendedDays: new FormControl(""),
      exetendedPoints: new FormControl(""),
    })
    this.assignProfileOwner = new FormGroup({
      profileOwner: new FormControl(null),
      secondprofileOwner: new FormControl(null)
    })
    this.loginDataStore.getStoreData('empData')
      .then((dataRes: any) => {
        this.loginData = JSON.parse(dataRes);
        // console.log(this.loginData)
        this.showCallRecordings = this.loginData['isManagement'] === 1 ||  this.loginData['isCallRecordAccess'] === 1 ? true : false
        this.getBranchWIseEmp(this.loginData);
      })
      .catch((err) => console.error(err));
    this.dataSource = new MatTableDataSource(this.data);
    if (this.formValue) {
      this.SAAmount = this.formValue['saAmount'];
      this.isSAEnabled = true;
    }
    if (this.type === 'profileAssign') {
      this.LoaderComponent = LoaderComponent
      this.service.getAdminMasterData().then((response) => {
        if (response['statusCode'] === 200) {
          this.LoaderComponent = '';
          this.profileOwnerArray = response['result'][4];
        } else {
          this.LoaderComponent = '';

        }

      })
    }
    if (this.searchSub) {
      const d = document.querySelector(".mat-elevation-z8-default");
      if (d) {
        d.scrollBy(this.service.positionA, this.service.positionB);
      }
    }
    if(this.type === 'keywordSearch' && this.formValue['fromProfileID']){
      this.fromProfileIdFocusIn(this.formValue['fromProfileID'])
    }
  }
  openExportPopup(){
    this.excelModal.show();
  }
  onProfileOwnerChange(selectedProfileOwner) {
    if(selectedProfileOwner && selectedProfileOwner.length > 0) {
    this.profileOwnerArray.find(profileOwner =>
    {
      if(profileOwner.id === selectedProfileOwner[0]?.id) {
        this.matchingProfileOwner = profileOwner
      }
    });
    if(this.matchingProfileOwner) {
      if(selectedProfileOwner[0]) {
      selectedProfileOwner[0].isManagement = this.matchingProfileOwner?.isManagement
      }
    }
  }
  }
  onSecondaryOwnerChange(selectedSecondaryOwner) {
    if(selectedSecondaryOwner && selectedSecondaryOwner.length > 0) {
    this.profileOwnerArray.find(profileOwner =>
    {
      if(profileOwner.id === selectedSecondaryOwner[0]?.id) {
        this.matchingSecondaryOwner = profileOwner
      }
    });
    if(this.matchingSecondaryOwner) {
      if(selectedSecondaryOwner[0]) {
      selectedSecondaryOwner[0].isManagement = this.matchingSecondaryOwner?.isManagement
      }
    }
  }
  }
  myProfileExportRecords(){
    this.difference = this.toValue - this.fromValue;
    console.log(this.difference);
     if ( this.fromValue >= this.toValue ) {
       this.invalidDifference = true;
       this.exportRecordsErrMsg = 'From Value should be less than To Value';
     } else if(this.difference > 1000){
       this.invalidDifference = true;
       this.exportRecordsErrMsg = 'Maximum limit should always be 1000';
     }
     else {
        this.invalidDifference = false;
        this.myProfileReqObj['pagefrom'] = this.fromValue;
        this.myProfileReqObj['pageto'] = this.toValue;
        console.log(this.myProfileReqObj);
        this.LoaderComponent = LoaderComponent;
        this.service.getMyProfiles(this.myProfileReqObj).then((res) =>{
          if(res['statusCode'] === 200){
            this.LoaderComponent = '';
            this.myProfileExportData = res['result'];
            this.exportProfile(this.myProfileExportData);
           console.log(res['result']);
          }
        })
        .catch(err => {
          this.LoaderComponent = '';
          console.log(err)
        })
      }
  }
  exportProfile(data) {
    let fileName = 'myProfileExportData.csv';
    let columnNames = ["Profile ID", " Surname", "First Name", "Gender", "Caste", "E-Grade", "Salary", "Property", "Registration Date", "Marital Status", "Profile Owner", "Secondary Owner", "Marketing Ticket", "Mob Login Count", "Web Login Count"];
    let header = columnNames.join(',');

    let csv = header;
    csv += '\r\n';

    data.map(c => {
      csv += [c["profileID"], c["lastName"], c["firstName"], c["Gender"], c['caste'], c['EducationGrade'], c['Salary'], c['Property'], c['RegistrationDate'], c['MaritalStatus'], c['profileOwnername'], c['SecondaryProfileOwner'], c['ticketID'], c['mobileLoginCount'], c['websiteLoginCount']].join(',');
      csv += '\r\n';
    })

    var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    var link = document.createElement("a");
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
closeExcelDialog(){
    this.excelModal.hide();
  }
  resetForm(){
    this.excelForm.reset();
    this.invalidDifference = false;
  }
  fromProfileIdFocusIn(profileID) {
      this.LoaderComponent = LoaderComponent;
      this.responseMessage = "";
      this.service.getRelationData(6, profileID, 0).then((response) => {
        if (response['statusCode'] === 200) {
          this.LoaderComponent = "";
          this.fromProfileIdData = response['result'][1][0];
          // console.log(this.fromProfileIdData)
        } else {
          this.LoaderComponent = "";
          this.responseMessage = response['message']
        }
      })

  }

  getCheckedProfile(element, event) {

    // this.removeChecked = $event.option.selected
    // console.log($event)
    this.toProfileIDAllData = [];
    this.toProfileIDAllData = element;
    let index = this.allSelectedProfiles.indexOf(element.profileID)
    if(index === -1 && event.checked === true){
        this.responseMessage = "";
        this.LoaderComponent = LoaderComponent;
        this.service.getRelationData(6, element.profileID, 0).then((response) => {
          if (response['statusCode'] === 200) {
            this.LoaderComponent = "";
            if (response['result'].length > 0) {
              if ((response['result'][0][0]['ProfileStatusID'] === 54) || (response['result'][0][0]['ProfileStatusID'] === 395) || (response['result'][0][0]['ProfileStatusID'] === 604)) {
                if (response['result'][1].length > 0) {
                  this.toProfileIdData = response['result'][1][0];
                  this.alertMessage = [];
                  if ((this.fromProfileIdData['GenderID'] === 1 && parseInt(this.fromProfileIdData['selfAge']) > parseInt(this.toProfileIdData['selfAge'])) || (this.fromProfileIdData['GenderID'] === 2 && parseInt(this.fromProfileIdData['selfAge']) < parseInt(this.toProfileIdData['selfAge']))) {
                    this.alertMessage.push("Age not matched to this profile \n");
                  }
                  // if ((this.fromProfileIdData.GenderID == "1" && parseInt(this.toProfileIdData.selfAge) < parseInt(this.fromProfileIdData.selfAge)) || (this.fromProfileIdData.GenderID == "2" && parseInt(this.toProfileIdData.selfAge) > parseInt(this.fromProfileIdData.selfAge))) {
                  //   this.alertMessage.push("Age not Matched to this profileid \n");
                  // }
                  if (this.fromProfileIdData.GenderID === this.toProfileIdData.GenderID) {
                    this.alertMessage.push("Gender not matched to this profile \n");
                  }


                  if ((this.fromProfileIdData['GenderID'] === 1 && parseInt(this.fromProfileIdData['selfheightID']) > parseInt(this.toProfileIdData['selfheightID'])) || (this.fromProfileIdData['GenderID'] === 2 && parseInt(this.fromProfileIdData['selfheightID']) < parseInt(this.toProfileIdData['selfheightID']))) {
                    this.alertMessage.push("Height not matched to this profile\n");
                  }

                  if (this.fromProfileIdData['selfmaritalstatusid'] !== this.toProfileIdData['selfmaritalstatusid']) {
                    this.alertMessage.push("Marital status not matched to this profile \n");
                  }

                  if (this.fromProfileIdData['SelfCaste'] != this.toProfileIdData['SelfCaste']) {
                    this.alertMessage.push("Caste not matched to this profile \n");

                  }
                  if ((this.fromProfileIdData['CSName'] !== null && this.fromProfileIdData['CSName'].toLowerCase()) === (this.toProfileIdData['CSName'] !== null && this.toProfileIdData['CSName'].toLowerCase())) {
                    this.alertMessage.push("Same Surname do you want to continue \n");
                  }
                  if ((this.fromProfileIdData['Gotram'] !== null && this.fromProfileIdData['Gotram'].toLowerCase()) === (this.toProfileIdData['Gotram'] !== null && this.toProfileIdData['Gotram'].toLowerCase())) {
                    this.alertMessage.push("Same Gothram do you want to continue \n");
                  }
                  if (this.fromProfileIdData['GenderID'] === this.toProfileIdData['GenderID']) {
                    this.responseMessage = "";
                    this.responseMessage = "Gender not matched to this profile";
                    this.alertModal.show();
                    this.alertMessage = [];
                    setTimeout(() => {
                      this.alertModal.hide();
                    }, 5000)
                    element.checked = false;
                    // this.expressForm.controls['toProfileID'].setValue('');

                  } else if (this.alertMessage.length > 0) {
                    this.warningModal.show();
                  } else {
                    this.allSelectedProfiles.push(element.profileID)
                    this.sendFromProfileIDs.push(element)
                    // this.addToSelectedProfilesList(element.profileID)
                  }

                } else {
                  this.responseMessage = "Basic details are required to send service";
                  this.alertModal.show();
                  // this.expressForm.controls['toProfileID'].setValue('');
                  element.checked = false;
                  setTimeout(() => {
                    this.alertModal.hide();
                  }, 5000)
                }


              } else if ((response['result'][0][0]['ProfileStatusID'] === 57) || (response['result'][0][0]['ProfileStatusID'] === 393)) {
                if (this.fromProfileIdData['GenderID'] != this.toProfileIdData['GenderID']) {
                  this.responseMessage = "";
                  this.responseMessage = "Settled or WaitingforSettled Authorization Profile";
                  this.alertModal.show();
                  // this.expressForm.controls['toProfileID'].setValue('');
                  element.checked = false;
                  setTimeout(() => {
                    this.alertModal.hide();
                  }, 5000)
                }
              } else if ((response['result'][0][0]['ProfileStatusID'] === 56) || (response['result'][0][0]['ProfileStatusID'] === 394)) {
                this.responseMessage = "";
                this.responseMessage = "Deleted or WaitingforDeltd authorization Profile";
                this.alertModal.show();
                // this.expressForm.controls['toProfileID'].setValue('');
                element.checked = false;
                setTimeout(() => {
                  this.alertModal.hide();
                }, 5000)
              }
              else {
                this.responseMessage = "Not Active Profile";
                this.alertModal.show();
                // this.expressForm.controls['toProfileID'].setValue('');
                element.checked = false;
                setTimeout(() => {
                  this.alertModal.hide();
                }, 5000)
                return
              }
            }
          } else {
            this.LoaderComponent = "";
            this.responseMessage = response['message']
            this.alertModal.show();
            // this.expressForm.controls['toProfileID'].setValue('');
            element.checked = false;
            setTimeout(() => {
              this.alertModal.hide();
            }, 5000);

          }
        })
      } else {
        this.allSelectedProfiles.splice(index, 1);
        this.sendFromProfileIDs.push(element)
      }
  }
  dontAddProfileIdToList(element){
    element.checked = false;
    this.warningModal.hide();
  }

  getBranchWIseEmp(loginData) {
    this.service.loadMasterDataWithId('ProfileOwner', parseInt(loginData['branch']))
      .then((empResult) => {
        this.empNameMultiSelectItems = empResult['result'];
        this.logeedInUser = [this.getEmployee(this.loginData['employeeID'])];
      })
  }
  getEmployee(id) {
    return this.empNameMultiSelectItems.find(val => {
      if (id == val.id) {
        return val;
      }
    })
  }
  onEmpnameItemSelect(element) {
    this.updateReAssignData.emit(element);
    this.selectedOwnerId = element.id;
  }
  onEmpnameItemDeSelect(e) {
    this.empNameMultiSelectItems.forEach(item => item.checked = false
    );
    this.checkedProfileId = [];
    this.isProfileChecked = false;
    this.data.forEach(item => item.checked = false);
    this.dataSource = new MatTableDataSource(this.data);
    this.cdr.detectChanges();
//    this.generalFormSearch.get('profileOwner')?.setValue([]);
  //  this.generalFormSearch.get('secondprofileOwner')?.setValue([]);
  }

  confirmPopup() {
    const profileOwner = this.assignProfileOwner.value.profileOwner;
    const secondaryProfileOwner = this.assignProfileOwner.value.secondprofileOwner;

    const firstProfile = this.data.find(item =>
      this.checkedProfileId.includes(item.ProfileID)
    );

    const selectedPrimaryOwnerId = profileOwner?.[0]?.id;
    const selectedSecondaryOwnerId = secondaryProfileOwner?.[0]?.id;

    const existingPrimaryOwnerId = firstProfile?.ProfileOwnerID;
    const existingPrimaryOwnerName = firstProfile?.ProfileOwnerName;

    const existingSecondaryOwnerId = firstProfile?.SecondaryProfileOwnerID;
    const existingSecondaryOwnerName = firstProfile?.SecondaryProfileOwnerName;

    const isPrimaryOwnerChanged = selectedPrimaryOwnerId && selectedPrimaryOwnerId !== existingPrimaryOwnerId;
    const isSecondaryOwnerChanged = selectedSecondaryOwnerId && selectedSecondaryOwnerId !== existingSecondaryOwnerId;

    const finalPrimaryOwnerName = profileOwner?.[0]?.value || existingPrimaryOwnerName;
    const finalSecondaryOwnerName = secondaryProfileOwner?.[0]?.value || existingSecondaryOwnerName;
    if (!this.checkedProfileId || this.checkedProfileId.length == 0) {
      this.responseMessage = 'Please select the profile  to assign the owner';
      this.isProfileChecked = false;
      this.successModal.show()
      setTimeout(() => {
        this.successModal.hide();
      }, 5000);
      return
    }
    // Check if a secondary owner is selected or not


    if (profileOwner && profileOwner.length > 0) {
      // If secondary owner exists
      if (secondaryProfileOwner && secondaryProfileOwner.length > 0) {
        this.responseMessage = `Are you sure you want to re-assign profiles to ${profileOwner[0].value} and ${secondaryProfileOwner[0]?.value}?`;
      } else {
        // If secondary owner is not selected, just show the message for primary owner
        this.responseMessage = `Are you sure you want to re-assign profiles to ${profileOwner[0].value}?`;
      }
    }
    else {
      this.responseMessage = 'Please select the profile to assign the owner';
      this.alertModal.show();
      setTimeout(() => {
        this.alertModal.hide();
      }, 5000);
      return;
    }

    // Show the confirmation modal
    this.confirmModal.show();
    setTimeout(() => {
      this.confirmModal.hide();
    }, 5000);

  }

  getCheckedProfileAfterWarning(event){

    let index = this.allSelectedProfiles.indexOf(event.profileID)
    if(index === -1){
      this.allSelectedProfiles.push(event.profileID)
      this.sendFromProfileIDs.push(event)
    } else {
      this.allSelectedProfiles.splice(index, 1);
      this.sendFromProfileIDs.push(event)
    }
    this.warningModal.hide();
    // console.log(this.allSelectedProfiles)
  }

  sendServiceFromKeywordSearch(){
      // this.showExpressIntrest = true
      // this.expressModal.show()
      // this.shortListServiceModal.hide()
      if (this.sendFromProfileIDs.length > 0) {
        // this.service.sendData(this.sendFromProfileIDs)
        this.expressData.emit(this.sendFromProfileIDs)
      }

  }
  closeExpressPopup(e){
    if (e == true) {
      this.expressModal.hide()
    }
  }
  private isSameSecondaryOwnerSelected(profileId: number, selectedSecondaryOwnerId: any): boolean {
    const existingSecondaryOwnerId = this.data.find(item => item.ProfileID === profileId)?.ProfileSecondaryOwnerID;
    return !!selectedSecondaryOwnerId && !!existingSecondaryOwnerId && parseInt(selectedSecondaryOwnerId) === parseInt(existingSecondaryOwnerId);
  }
  private isSamePrimaryOwnerSelected(profileId: number, selectedPrimaryOwnerId: any): boolean {
    const existingPrimaryOwnerId = this.data.find(item => item.ProfileID === profileId)?.ProfileOwnerID;
    return !!selectedPrimaryOwnerId && !!existingPrimaryOwnerId && parseInt(selectedPrimaryOwnerId) === parseInt(existingPrimaryOwnerId);
  }
  checkedItem(profile) {
    profile.checked = !profile.checked;
    const secondProfileOwnerData = this.assignProfileOwner.get('secondprofileOwner').value;
    const isChecked = profile.checked;
    const paidSatus = profile.paidSatus;
    const profileId = profile.ProfileID;
    let messageData = {
      profileOwner: this.assignProfileOwner.value['profileOwner'],
      secondaryOwner: this.assignProfileOwner.value['secondprofileOwner']
    }
    let profileOwnerName = messageData?.profileOwner?.[0]?.value;
    let secondaryOwnerName = messageData?.secondaryOwner?.[0]?.value;
    let RM1Branch = profileOwnerName ? profileOwnerName.substring(profileOwnerName.indexOf('(') + 1, profileOwnerName.indexOf('(') + 3) : null;
    let RM2Branch = secondaryOwnerName ? secondaryOwnerName.substring(secondaryOwnerName.indexOf('(') + 1, secondaryOwnerName.indexOf('(') + 3) : null;
    const selectedSecondaryOwnerId = messageData.secondaryOwner?.[0]?.id;
    const selectedPrimaryOwnerId = messageData.profileOwner?.[0]?.id;
    const existingSecondaryOwnerId = this.data.find(item => item.ProfileID === profileId)?.ProfileSecondaryOwnerID;
    const existingPrimaryOwnerId = this.data.find(item => item.ProfileID === profileId)?.ProfileOwnerID;
    const isSecondaryOwnerChanged = selectedSecondaryOwnerId && selectedSecondaryOwnerId !== existingSecondaryOwnerId;
    const isPrimaryOwnerChanged = selectedPrimaryOwnerId && selectedPrimaryOwnerId !== existingPrimaryOwnerId;
    const existingPrimaryOwnerName = this.data.find(item => item.ProfileID === profileId)?.ProfileOwner;
    const existingSecondaryOwnerName = this.data.find(item => item.ProfileID === profileId)?.ProfileSecondaryOwner;
    const existingRM1Branch = existingPrimaryOwnerName
      ? existingPrimaryOwnerName.substring(existingPrimaryOwnerName.indexOf('(') + 1, existingPrimaryOwnerName.indexOf('(') + 3)
      : null;
    const existingRM2Branch = existingSecondaryOwnerName
      ? existingSecondaryOwnerName.substring(existingSecondaryOwnerName.indexOf('(') + 1, existingSecondaryOwnerName.indexOf('(') + 3)
      : null;

    if ((!messageData.profileOwner || messageData.profileOwner.length === 0) && !isSecondaryOwnerChanged && !isPrimaryOwnerChanged) {
      if (this.isSameSecondaryOwnerSelected(profileId, selectedSecondaryOwnerId)) {
        this.responseMessage = "Selected Secondary Owner is already assigned to this profile";
      }
      else if (this.isSamePrimaryOwnerSelected(profileId, selectedPrimaryOwnerId)) {
        this.responseMessage = "Selected Primary Owner is already assigned to this profile";
      } else {
        this.responseMessage = 'Please select a primary profile owner';
      }
      this.updateCheckedState(profileId, false);
      return;
    }
    // Check if Primary and Secondary Owners are the same
    if(messageData.profileOwner && messageData.secondaryOwner && parseInt(messageData.profileOwner[0]?.id)===parseInt(messageData.secondaryOwner[0]?.id)){
      this.responseMessage = "Both Primary Owner and Secondary Owner should not be same";
      this.updateCheckedState(profileId, false);
    return;
    }
    // Check if Primary and Secondary Owners are from the same branch
     if(messageData.profileOwner != null && messageData.secondaryOwner != null && RM1Branch === RM2Branch && messageData.profileOwner[0].isManagement != true && messageData.secondaryOwner[0].isManagement != true) {
        this.responseMessage = "Cannot Assign Primary Owner and Secondary Owner from same Branch";
        this.updateCheckedState(profileId, false);
        return;
    }
    if (
      isSecondaryOwnerChanged &&
      selectedSecondaryOwnerId &&
      !isPrimaryOwnerChanged &&
      existingPrimaryOwnerId &&
      parseInt(selectedSecondaryOwnerId) === parseInt(existingPrimaryOwnerId)
    ) {
      this.responseMessage = "Secondary Owner should not be the same as the existing Primary Owner";
      this.updateCheckedState(profileId, false);
      return;
    }
    if (
      isPrimaryOwnerChanged &&
      !isSecondaryOwnerChanged &&
      selectedPrimaryOwnerId &&
      existingSecondaryOwnerId &&
      parseInt(selectedPrimaryOwnerId) === parseInt(existingSecondaryOwnerId)
    ) {
      this.responseMessage = "Primary Owner should not be the same as the existing Secondary Owner";
      this.updateCheckedState(profileId, false);
      return;
    }
     if ((paidSatus === 1 || paidSatus === 2) &&
    (secondProfileOwnerData == undefined || secondProfileOwnerData == null || secondProfileOwnerData.length === 0)) {

  this.responseMessage = 'Please select a secondary profile owner';
  this.updateCheckedState(profileId, false);
  return;
} else {
  const selectedProfileOwnerId = messageData.profileOwner?.[0]?.id;
  const selectedSecondaryOwnerId = messageData.secondaryOwner?.[0]?.id ?? null;
  const checkedProfileOwnerId = this.data.find(item => item.ProfileID === profileId)?.ProfileOwnerID;  // Assuming `profileOwnerId` is the field for the checked profile's owner
  const checkedSecondaryOwnerId = this.data.find(item => item.ProfileID === profileId)?.ProfileSecondaryOwnerID; // Assuming `profileSecondaryOwnerId` is the field for the checked profile's secondary owner
  if (
     selectedProfileOwnerId === checkedProfileOwnerId &&
       selectedSecondaryOwnerId === checkedSecondaryOwnerId) {
      this.responseMessage = 'Checked profile and assign profile owner are same, please select a different profile owner';
      this.updateCheckedState(profileId, false);
    return;
  }
  if (
    isSecondaryOwnerChanged &&
    !isPrimaryOwnerChanged &&
    existingPrimaryOwnerName &&
    RM2Branch === existingRM1Branch
  ) {
    this.responseMessage = "Selected Secondary Owner cannot be from the same branch as the existing Primary Owner";
    this.updateCheckedState(profileId, false);
    return;
  }
  if (
    isPrimaryOwnerChanged &&
    !isSecondaryOwnerChanged &&
    existingSecondaryOwnerName &&
    RM1Branch === existingRM2Branch
  ) {
    this.responseMessage = "Selected Primary Owner cannot be from the same branch as the existing Secondary Owner";
    this.updateCheckedState(profileId, false);
    return;
  }


      else {
        var index = this.checkedProfileId.indexOf(profileId);
        if (index === -1) {
          this.checkedProfileId.push(profileId);
        } else {
          this.checkedProfileId.splice(index, 1);
        }
      }
    }

  }
  updateCheckedState(profileId: any, checked: boolean) {
    this.data = this.data.map(item =>
      item.ProfileID === profileId ? { ...item, checked: false } : item
    );
    this.isProfileChecked = false;
    this.checkedProfileId = this.checkedProfileId.filter(id => id !== profileId);
    this.alertModal.show();
    setTimeout(() => this.alertModal.hide(), 5000);
    return;
   }
  selectAllProfiles(event, data) {
    const profileOwnerData = this.assignProfileOwner.get('profileOwner').value
    if (profileOwnerData == null || profileOwnerData.length == 0) {
      this.responseMessage = 'Please Select a profile owner'
      this.data.forEach((item) =>
        item.checked = false
      );
      this.successModal.show()
      this.checkedProfileId = []
      setTimeout(() => {
        this.successModal.hide();
      }, 5000);
    } else {
      if (event.checked) {
        this.isProfileChecked = true;
        this.data.forEach(item => item.checked = true);
        this.data.forEach(item => {
          var index = this.checkedProfileId.indexOf(item.ProfileID);
          if (index === -1) {
            this.checkedProfileId.push(item.ProfileID);
          } else {
            this.checkedProfileId.splice(index, 1);
          }
        });
      } else {
        this.isProfileChecked = false;
        this.data.forEach(item => item.checked = false);
        this.checkedProfileId = [];
      }
    }

  }
  submitReassignData() {
    const profileOwner = this.assignProfileOwner.value.profileOwner;
    const secondaryProfileOwner = this.assignProfileOwner.value.secondprofileOwner;
    const firstProfile = this.data.find(item =>
      this.checkedProfileId.includes(item.ProfileID)
    );

    const fallbackPrimaryOwner = {
      value: firstProfile?.ProfileOwner || 'N/A',
      id: firstProfile?.ProfileOwnerID || null
    };

    const fallbackSecondaryOwner = {
      value: firstProfile?.ProfileSecondaryOwner || 'N/A',
      id: firstProfile?.ProfileSecondaryOwnerID || null
    };

    const assignSecondEmpID = (secondaryProfileOwner && secondaryProfileOwner.length > 0)
    ? secondaryProfileOwner[0].id
    : (fallbackSecondaryOwner.id || 0);

     let object: any = {
      assignEmpID: profileOwner?.[0]?.id || fallbackPrimaryOwner.id,
      profileIDs: String(this.checkedProfileId),
      loginEmpID: this.loginData['employeeID'],
      assignSecondEmpID: assignSecondEmpID
    };
    this.submitGridData.emit(object)
  }
  resetUnassignSlideData() {
    this.assignProfileOwner.reset();
    this.data.forEach(item => item.checked = false);
    this.dataSource = new MatTableDataSource(this.data);
    this.isProfileChecked = false;
    this.checkedProfileId = [];
    this.cdr.detectChanges();
  }
  handleScroll() {
    const d = document.querySelector(".mat-elevation-z8-default");
      if (d) {
        this.service.counter = this.service.counter + 1;
        this.service.positionB = this.service.positionB + 2700;
        d.scrollBy(this.service.positionA , this.service.positionB);
      }
  }

  // scrollHandler(e){
  //   var elmnt = document.getElementById("default-content");
  //   console.log(elmnt.scrollTop)
  // }


  public clearManualPage(): void {
    this.manualPage = 0;
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    // var objDiv = document.getElementById("default-content");
    // objDiv.scrollTop = objDiv.scrollHeight;
    if (this.scrollDown) {
      this.handleScroll();
    }
  }

  onClickRow(value, header, entireRow) {
    if (header != 'TicketID' && header != 'icon' && entireRow['ProfileID'] != null && entireRow['ProfileID'] != ""
      && header != 'Marketingticketid' && header != 'TicketHistoryID') {
      window.open(`/viewProfile;id=${entireRow['ViewfullProfileID']}`, '_blank');
    } else if (header === 'TicketID' || header === 'Marketingticketid' || header === 'TicketHistoryID') {
      this.modalBoolean = true;
      this.ticketId = entireRow['TicketID']
    } else if (header === 'icon') {

    }
  }
  viewTicket(id){
    this.modalBoolean=false;
    this.ticketId=""
    if(id!=null){
      setTimeout(()=>{
        this.modalBoolean=true;
        this.ticketId = id;
      })
    }


  }

  openCountModal(type) {

    switch(type){
      case 'active':
        this.slideForm['applicationstatus'] = 54
        this.playProfileValidationSlideShow(this.slideForm)
      break;
      case 'delete':
        this.slideForm['applicationstatus'] = 56
        this.playProfileValidationSlideShow(this.slideForm)
      break;
      case 'settled':
        this.slideForm['applicationstatus'] = 57
        this.playProfileValidationSlideShow(this.slideForm)
      break;
      case 'inActive':
        this.slideForm['applicationstatus'] = 55
        this.playProfileValidationSlideShow(this.slideForm)
      break;
      case 'serious':
      this.slideForm['applicationstatus'] = 604
      this.playProfileValidationSlideShow(this.slideForm)
      break;
      case 'mmSerious':
        this.slideForm['applicationstatus'] = 395
        this.playProfileValidationSlideShow(this.slideForm)
      break;
    }

  }

  playSlideShowProfileValidation(){
    this.playProfileValidationSlideShow(this.slideForm)
  }


  // playProfileValidationSlideShow(formValue) {
  //   this.slideShowForm ="";
  //   setTimeout(()=>{
  //     if (!this.isPlaySideShow) {
  //       this.LoaderComponent =LoaderComponent;
  //       this.slideShowForm = formValue;
  //       this.mode="profileValidation"
  //       this.slideShowForm['startindex'] = 1;
  //       this.slideShowForm['endIndex'] = 10;
  //       this.isPlaySideShow = true;
  //       this.LoaderComponent  = "";
  //     }

  //   },10)
  // }

  playProfileValidationSlideShow(formValue) {
    this.slideShowForm ="";
    this.slideShowForm = formValue;
    this.slideShowForm['startindex'] = 1;
    this.slideShowForm['endIndex'] = 10;
    let dialogRef = this.dialog.open(EditViewSlideShowComponent, {
      maxWidth: '90vw',
      width: '100%',
      height: '91%',
      disableClose: true,
      data: {
        formValue: this.slideShowForm,
        mode: 'profileValidation',
      }
    });


    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
      this.mode="profileValidation"
      this.slideShowForm ="";
    });
        // setTimeout(()=>{
          //   if (!this.isPlaySideShow) {
            //     this.LoaderComponent =LoaderComponent;
            // this.isPlaySideShow = true;

    //   }

    // },10)

  }

  myProfileGridSlideShow(){
    let dialogRef = this.dialog.open(OldSlideShowComponent, {
      maxWidth: '90vw',
      width: '100%',
      height: '91%',
      disableClose: true,
      data: {
        formValue: this.myProfiles[0],
        mode: 'myProfile',
        display: this.display,
        reqObj: this.reqObj,
        DORTable: true
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
      this.mode="myProfile"
    });
  }


  closeSlideShowModal(event){
    this.isPlaySideShow = false;
    this.mode="profileValidation"
    this.slideShowForm ="";

  }
  // copyProfileId(profileId,event){
  //   this.utilitiesService.copyProfileId(profileId,event);
  // }

  getModifiedProfileId(property, element) {
    if (property === 'ProfileID' && element['SubscriptionServiceTypeId'] ===601
    || property === 'ProfileID' && element['SubscriptionServiceTypeId'] ===parseInt('601')) {
      return element['ProfileID'] + ' -R'
    } else if (property === 'ProfileID' && element['SubscriptionServiceTypeId'] ===602 ||
    (property === 'ProfileID' && element['SubscriptionServiceTypeId'] ===parseInt('602'))) {
      return element['ProfileID'] + ' -A'
    } else if (property === 'ProfileID' && element['SubscriptionServiceTypeId'] === 603 ||
    property === 'ProfileID' && element['SubscriptionServiceTypeId'] === parseInt('603')) {
     return element['ProfileID'] + ' -C'
    } else if (property === 'ProfileID' && element['SubscriptionServiceTypeId'] === null ||
    property === 'ProfileID' && element['SubscriptionServiceTypeId']===600 ||
    property === 'ProfileID' && element['SubscriptionServiceTypeId']===parseInt('600') ||
    element['SubscriptionServiceTypeId'] === 0
    || element['SubscriptionServiceTypeId'] === '') {
      return element['ProfileID']
    }
  }

  getModifyProfileId(property, element) {
    if (property === 'profileid' && element['SubscriptionServiceTypeId'] ===601
    || property === 'profileid' && element['SubscriptionServiceTypeId'] ===parseInt('601')) {
      return element['profileid'] + ' -R'
    } else if (property === 'profileid' && element['SubscriptionServiceTypeId'] ===602 ||
    (property === 'profileid' && element['SubscriptionServiceTypeId'] ===parseInt('602'))) {
      return element['profileid'] + ' -A'
    } else if (property === 'profileid' && element['SubscriptionServiceTypeId'] === 603 ||
    property === 'profileid' && element['SubscriptionServiceTypeId'] === parseInt('603')) {
     return element['profileid'] + ' -C'
    } else if (property === 'profileid' && element['SubscriptionServiceTypeId'] === null ||
    property === 'profileid' && element['SubscriptionServiceTypeId']===600 ||
    property === 'profileid' && element['SubscriptionServiceTypeId']===parseInt('600') ||
    element['SubscriptionServiceTypeId'] === 0
    || element['SubscriptionServiceTypeId'] === '') {
      return element['profileid']
    }
  }

  getAdminProfileId(property,element){
    if(property === 'profileID' && element['subscriptionServiceTypeId'] === parseInt('601')){
      return element['profileID'] + ' -R';
    } else if(property === 'profileID' && element['subscriptionServiceTypeId'] === parseInt('602')){
      return element['profileID'] + ' -A';
    } else if(property === 'profileID' && element['subscriptionServiceTypeId'] === parseInt('603')){
      return element['profileID'] + ' -C';
    } else if(property === 'profileID' && element['subscriptionServiceTypeId'] === parseInt('604')){
      return element['profileID'] + ' -SC';
    } else {
      return element['profileID'];

    }
  }
  getProfileIdWithProfileTypesAssign(property, element) {
    if (property === 'ProfileID' && element['ServiceType'] === 601) {
      return element['ProfileID'] + '-  R'
    } else if (property === 'ProfileID' && element['ServiceType'] === 602) {
      return element['ProfileID'] + '-  A'
    } else if (property === 'ProfileID' && element['ServiceType'] ===216) {
      const grade = element['ConfidentialGrade'] != null ? ('- C' + element['ConfidentialGrade']) : '- C';
      return element['ProfileID'] + grade
    } else if (property === 'ProfileID' && element['ServiceType'] ===217) {
      const grade = element['ConfidentialGrade'] != null ? ('- C' + element['ConfidentialGrade']) : '- C';
      return element['ProfileID'] + grade
    } else if (property === 'ProfileID' && element['ServiceType'] ===218) {
      const grade = element['ConfidentialGrade'] != null ? ('- C' + element['ConfidentialGrade']) : '- C';
      return element['ProfileID'] + grade
    } else if (property === 'ProfileID' && element['ServiceType'] ===219) {
      const grade = element['ConfidentialGrade'] != null ? ('- C' + element['ConfidentialGrade']) : '- C';
      return element['ProfileID'] + grade
    } else if (property === 'ProfileID' && element['ServiceType'] === 604) {
      const grade = element['isSuperHighConfidential'] ?  '- NX' : '- SC';
      return element['ProfileID'] + grade
    } else if (property === 'ProfileID' && element['ServiceType'] === 600) {
      return element['ProfileID']   } else if (property === 'ProfileID' && element['ServiceType'] === null ||
    (property === 'ProfileID' && element['SubscriptionServiceTypeId'] === null)) {
      return element['ProfileID']
    }
  }

  getProfileIdWithProfileTypes(property, element) {
    if (property === 'ProfileID' && element['ServiceType'] === "601" ||
    (property === 'ProfileID' && element['SubscriptionServiceTypeId'] === 601)) {
      return element['ProfileID'] + '-  R'
    } else if (property === 'ProfileID' && element['ServiceType'] === "602"||
    (property === 'ProfileID' && element['SubscriptionServiceTypeId']=== 602)) {
      return element['ProfileID'] + '-  A'
    } else if (property === 'ProfileID' && element['ServiceType'] ==="603"||
    (property === 'ProfileID' && element['SubscriptionServiceTypeId'] === 603)) {
      const grade = element['confidentialGrade'] != null ? ('- C' + element['confidentialGrade']) : '- C';
      return element['ProfileID'] + grade
    } else if (property === 'ProfileID' && element['ServiceType'] === "604"||
    (property === 'ProfileID' && element['SubscriptionServiceTypeId'] === 604)) {
      return element['isSuperHighConfidential'] ? element['ProfileID'] + '- NX' : element['ProfileID'] + '- SC'
    } else if (property === 'ProfileID' && element['ServiceType'] === "600"||
    (property === 'ProfileID' && element['SubscriptionServiceTypeId'] === 600)) {
      return element['ProfileID']
    } else if (property === 'ProfileID' && element['ServiceType'] === null ||
    (property === 'ProfileID' && element['SubscriptionServiceTypeId'] === null)) {
      return element['ProfileID'];
    }

    if (property === 'profileID' && element['serviceType'] === "601" || property === 'profileID' && parseInt(element['subscriptionServiceTypeId']) === 601) {
      return !element['profileID'].includes('R') ?  element['profileID'] + '-  R' : element['profileID'];
    } else if (property === 'profileID' && element['serviceType'] === "602" || property === 'profileID' && parseInt(element['subscriptionServiceTypeId']) === 602) {
      return !element['profileID'].includes('A') ?  element['profileID'] + '-  A' : element['profileID'];
    } else if (property === 'profileID' && element['serviceType'] ===  "603" || property === 'profileID' && parseInt(element['subscriptionServiceTypeId']) === 603) {
      const grade = element['confidentialGrade'] != null ? ('- C' + element['confidentialGrade']) : '- C';
      return element['confidentialGrade'] != null ? !element['profileID'].includes('C') ? (element['profileID'] + '- C' + element['confidentialGrade']) : (element['profileID'] + element['confidentialGrade']) : element['profileID'];
    } else if (property === 'profileID' && element['serviceType'] === "604" || property === 'profileID' && parseInt(element['subscriptionServiceTypeId']) === 604) {
      return !element['profileID'].includes('SC') ?  element['isSuperHighConfidential'] ? element['profileID'] + '- NX' : element['profileID'] + '-  SC' : element['profileID'];
    } else if (property === 'profileID' || property === 'profileID' && element['serviceType'] === "600" || property === 'profileID' && parseInt(element['subscriptionServiceTypeId']) === 600) {
      return element['profileID']
    }

    if (property === 'fromProfileid' && element['ServiceType'] === parseInt("601") ||
    (property === 'fromProfileid' && element['fromSubscriptionServiceTypeId'] === 601)) {
      return element['fromProfileid'] + '-  R'
    } else if (property === 'fromProfileid' && element['ServiceType'] === parseInt("602")||
    (property === 'fromProfileid' && element['fromSubscriptionServiceTypeId']=== 602)) {
      return element['fromProfileid'] + '-  A'
    } else if (property === 'fromProfileid' && element['ServiceType'] ===parseInt("603")||
    (property === 'fromProfileid' && element['fromSubscriptionServiceTypeId'] === 603)) {
      const grade = element['fromConfidentialGrade'] != null ? ('- C' + element['fromConfidentialGrade']) : '- C';
      return element['fromProfileid'] + grade
    } else if (property === 'fromProfileid' && element['ServiceType'] === parseInt("604")||
    (property === 'fromProfileid' && element['fromSubscriptionServiceTypeId'] === 604)) {
      return element['fromIsSuperHighConfidential'] ? element['fromProfileid'] + '- NX' :  element['fromProfileid'] + '- SC'
    } else if (property === 'fromProfileid' || property === 'fromProfileid' && element['ServiceType'] === parseInt("600")||
    (property === 'fromProfileid' && element['fromSubscriptionServiceTypeId'] === 600)) {
      return element['fromProfileid']
    }

    if (property === 'toprofileid' && element['ServiceType'] === parseInt("601") ||
    (property === 'toprofileid' && element['toSubscriptionServiceTypeId'] === 601)) {
      return element['toprofileid'] + '-  R'
    } else if (property === 'toprofileid' && element['ServiceType'] === parseInt("602")||
    (property === 'toprofileid' && element['toSubscriptionServiceTypeId']=== 602)) {
      return element['toprofileid'] + '-  A'
    } else if (property === 'toprofileid' && element['ServiceType'] ===parseInt("603")||
    (property === 'toprofileid' && element['toSubscriptionServiceTypeId'] === 603)) {
      const grade = element['toConfidentialGrade'] != null ? ('- C' + element['toConfidentialGrade']) : '- C';
      return element['toprofileid'] + grade;
    } else if (property === 'toprofileid' && element['ServiceType'] === parseInt("604")||
    (property === 'toprofileid' && element['toSubscriptionServiceTypeId'] === 604)) {
      return element['toIsSuperHighConfidential'] ? element['toprofileid'] + '- NX' :  element['toprofileid'] + '- SC'
    } else if (property === 'toprofileid' || property === 'toprofileid' && element['ServiceType'] === parseInt("600")||
    (property === 'toprofileid' && element['toSubscriptionServiceTypeId'] === 600)) {
      return element['toprofileid']
    }
  }

  getAssignTicketColour(property, element) {
    if (property === 'profileID' && element['paidSatus'] === 1 || (property === 'profileID' && element['paid'] === 1) ||
    (property === 'profileID' && element['paidSatus'] === 1) || (property === 'profileID' && element['paidSatus'] === 1)||
    (property === 'profileID' && element['paidSatus'] === 1)||(property === 'profileID' && element['paidSatus'] === 1) ||
    (property === 'profileid' && element['paidSatus'] === 1)||(property === 'profileid' && element['paidSatus'] === 1) ||
    (property === 'profileID' && element['paidSatus'] === 1) || (property === 'ProfileID' && element['paidSatus'] === 1) ||
    (property === 'fromPaidStatus' && element['fromPaidStatus'] === 1) || (property === 'toPaidStatus' && element['toPaidStatus'] === 1) ||
    (property === 'profileID' && element['paidStatus'] === 1) || (property === 'ProfileID' && element['PaidStatus'] === 1)) {
      return 'green'
    } else if (property === 'profileID' && element['paidSatus'] === 2 || (property === 'profileID' && element['paid'] === 2) ||
    (property === 'profileID' && element['paidSatus'] === 2) || (property === 'profileID' && element['paidSatus'] === 2)||
    (property === 'profileID' && element['paidSatus'] === 2)|| (property === 'profileID' && element['paidSatus'] === 2) ||
    (property === 'profileid' && element['paidSatus'] === 2)|| (property === 'profileid' && element['paidSatus'] === 2) ||
    (property === 'profileID' && element['paidSatus'] === 2) || (property === 'ProfileID' && element['paidSatus'] === 2) ||
    (property === 'fromPaidStatus' && element['fromPaidStatus'] === 2) || (property === 'toPaidStatus' && element['toPaidStatus'] === 2) ||
    (property === 'profileID' && element['paidStatus'] === 2) || (property === 'ProfileID' && element['PaidStatus'] === 2)) {
      return 'blue'
    } else if (property === 'profileID' && element['paidSatus'] ===0 || (property === 'profileID' && element['paidSatus'] === 0) ||
    (property === 'profileID' && element['paidSatus'] === 0) || (property === 'profileID' && element['paid'] === 0) ||
    (property === 'profileID' && element['paidSatus'] === 0)||(property === 'profileID' && element['paidSatus'] === 0)||
    (property === 'profileid' && element['paidSatus'] === 0)||(property === 'profileid' && element['paidSatus'] === 0)||
    (property === 'profileID' && element['paidSatus'] === parseInt("603")) || (property === 'ProfileID' && element['paidSatus'] === 0) ||
    (property === 'fromPaidStatus' && element['fromPaidStatus'] === 0) || (property === 'toPaidStatus' && element['toPaidStatus'] === 0) ||
    (property === 'profileID' && element['paidStatus'] === 0) || (property === 'ProfileID' && element['PaidStatus'] === 0)) {
      return 'red'
    } else if (property === 'profileID' || property === 'profileID') {
      return 'red'
    }

    // if (property === 'profileID' && element['serviceType'] === "601") {


    //   return '#EC6227'
    // } else if (property === 'profileID' && element['serviceType'] === "602") {


    //   return '#006980'
    // } else if (property === 'profileID' && element['serviceType'] === "603") {

    //   return '#28009b'
    // } else if (property === 'profileID') {
    //   return 'red'
    // }
  }

  getColor(property, element) {
    if (property === 'ProfileID' && element['SubscriptionServiceTypeId'] === 601) {
      return '#EC6227'
    } else if (property === 'ProfileID' && element['SubscriptionServiceTypeId'] === 602) {
      return '#006980'
    } else if (property === 'ProfileID' && element['SubscriptionServiceTypeId'] === 603) {
      return '#28009b'
    } else if (property === 'ProfileID') {
      return 'red'
    }
    if (property === 'TicketID' || property === 'Marketingticketid' || property === 'TicketHistoryID') {
      return 'rgb(101,155,201)';
    } else {
      return '5B5B5B';
    }

  }

  getAdminProfileClr(property, element) {
    if (property === 'profileID' && element['subscriptionServiceTypeId'] === parseInt('601')) {
      return '#EC6227'
    } else if (property === 'profileID' && element['subscriptionServiceTypeId'] === parseInt('602')) {
      return '#006980'
    } else if (property === 'profileID' && element['subscriptionServiceTypeId'] ===parseInt('603')) {
      return '#28009b'
    } else if (property === 'profileID') {
      return 'red'
    }

  }
  onItemSelect(selectedItem) {
    this.defaultColumns.push(selectedItem.id)
  }
  onItemDeSelect(deselectedItem) {
    let index = this.defaultColumns.indexOf(deselectedItem.id);
    if (index >= 0) {
      this.defaultColumns.splice(index, 1);
    }
    if (this.defaultColumns.length == 1) {
      this.navigateToBack()
    }
  }
  getPaginationBounds(data) {
    this.pageEvent.emit(data);

  }
  navigateToBack() {
    this.navigateBack.emit(null);
  }

  trackByFn(index, item) {
    return item.id;
  }
  closeTicketModal(value) {
    this.modalBoolean = value;
    this.ticketId = "";
  }

  onDynamicClickRoe(col, ele) {

  }

  exportCSV() {
    if (this.type === 'profileAssign') {
      this.hidddenExported.exportTable('csv')
    } else {
      this.exported.exportTable('csv')
    }
  }

  getHeader(value) {
    for (let object of this.matchedHeaders) {
      if (object['value'] === value) {
        return object['title']
      } else if (object['id'] === value) {
        return object['name']
      }
    }
  }

  saveSA() {
    if (this.SAAmount != undefined) {
      if (this.formValue != undefined && this.formValue['custId'] != null) {
        this.responseMessage = ""
        let saObject = {
          custID: this.formValue['custId'],
          settleAmt: this.SAAmount
        }
        this.LoaderComponent = LoaderComponent;

        this.service.saveEditSA(saObject).then((response) => {
          if (response['statusCode'] === 200) {
            this.LoaderComponent = "";
            this.isSAEnabled = true;
            this.responseMessage = response['message'];
            this.successModal.show();
            setTimeout(() => {
              this.LoaderComponent = '';
              this.successModal.hide();
            }, 5000);
          }
        })
      }

    }
  }
  editSA() {
    this.isSAEnabled = false;
  }

  ngOnChanges() {
    if(this.grid2==='duplicateData'){
      this.data= this.data2;
      this.defaultColumns = this.defaultColumns2;
      this.matchedHeaders = this.matchedHeaders2;
      this.dataSource = new MatTableDataSource(this.data);
    }


  }
  viewSAForm() {
    this.enableSAForm.emit(true)
  }
  showDescription(value) {
    if (value) {
      this.descriptionMessage = value;
      this.descriptionModal.show();
    }
  }
  navigateToViewProfile() {
    window.open(`/viewProfile;id=${this.formValue['profileID']}`, '_blank');

  }
  navigateToViewProfileByProfileId(id,profileData){

    if(this.loginData.marketingProfileViewAccess && (profileData.profileStatusID === '56' || profileData.profileStatusID === '57' || profileData.ProfileStatusID === 56 || profileData.ProfileStatusID === 57)){
      this.marketingFormatAccess = true
    }
    this.redirectToViewProfile = this.marketingFormatAccess ? 4 : this.loginData.formatAccess;
    window.open(`/viewProfile;profileID=${id};format=${this.redirectToViewProfile}`, '_blank');

  }

  navigateToViewProfileByfromAndToCustID(from, to) {
    window.open(`/viewProfile;from=${from};to=${to}`, '_blank');
  }

  navigateToPaymentDetilsPage() {
    window.open(`/addPaymentDetails;id=${this.formValue['profileID']};paymentHistId=${this.formValue['paymentHist_ID']};membershipId=${this.formValue['memberShipTypeID']}`, '_blank');

  }

  navigateToPaymentPage(profileId){
    window.open(`/paymentDetails;id=${profileId}`,'_blank');

  }

  renewalTheProfile() {
    this.renewalEvent.emit(this.formValue['profileID']);
  }

  assignToOwener(eachProfile,profileId, ticketId, profileType, primaryOwner, secondaryOwner,selectedPrimaryOwner,selectedSecondaryOwner,exclusiveGrade) {
    if (eachProfile['PaidStatus'] === 1 || eachProfile['PaidStatus'] === 2) {
      if(primaryOwner != null && secondaryOwner != null && primaryOwner.length > 0 && secondaryOwner.length > 0 ){
        this.responseMessage = "";
         if(primaryOwner && secondaryOwner &&  parseInt(primaryOwner[0]['id'])===parseInt(secondaryOwner[0]['id']) || selectedPrimaryOwner && parseInt(selectedPrimaryOwner)=== secondaryOwner && parseInt(secondaryOwner[0]['id']) ||selectedSecondaryOwner && primaryOwner && parseInt(selectedSecondaryOwner) ===parseInt(primaryOwner[0]['id'])){
          this.responseMessage = "Both Primary Owner and Secondary Owner should not be same";
          this.successModal.show();
          setTimeout(() => {
            this.LoaderComponent = '';
            this.successModal.hide();
          }, 5000);
        }else{
          if(primaryOwner?.length > 0 && secondaryOwner?.length>0){
            let RM1Branch = primaryOwner?.[0].name.substring(primaryOwner?.[0].name.indexOf('(') + 1 , primaryOwner?.[0].name.indexOf('(') + 3)
            let RM2Branch = secondaryOwner?.[0].name.substring(secondaryOwner?.[0].name.indexOf('(') + 1 , secondaryOwner?.[0].name.indexOf('(') + 3)
             if (RM1Branch === RM2Branch){
                if(primaryOwner?.[0].isManagement != true && secondaryOwner?.[0].isManagement != true) {
                  this.responseMessage = "Cannot Assign Primary Owner and Secondary Owner from same Branch";
                  this.successModal.show();
                  setTimeout(() => {
                  this.LoaderComponent = '';
                  this.successModal.hide();
                 }, 5000);
                } else{
                 let profileObject = { profileId: profileId, cust_id: eachProfile['cust_id'], TicketID: ticketId, profileType: profileType, profileOwner: primaryOwner, secondaryOwner: secondaryOwner,SelectedProfileOwner:selectedPrimaryOwner,SelectedProfileSecondaryOwner: selectedSecondaryOwner, ExclusiveGrade: exclusiveGrade}
                 this.assignedOwner.emit(profileObject)
                }
            }
            else {
              let profileObject = { profileId: profileId, cust_id: eachProfile['cust_id'], TicketID: ticketId, profileType: profileType, profileOwner: primaryOwner, secondaryOwner: secondaryOwner,SelectedProfileOwner:selectedPrimaryOwner,SelectedProfileSecondaryOwner: selectedSecondaryOwner, ExclusiveGrade: exclusiveGrade}
              this.assignedOwner.emit(profileObject)
            }
          }
        }
      }else if (primaryOwner != null && exclusiveGrade){

        let profileObject = { profileId: profileId, cust_id: eachProfile['cust_id'], TicketID: ticketId, profileType: profileType, profileOwner: primaryOwner, secondaryOwner: secondaryOwner,SelectedProfileOwner:selectedPrimaryOwner,SelectedProfileSecondaryOwner: selectedSecondaryOwner, ExclusiveGrade: exclusiveGrade}
        this.assignedOwner.emit(profileObject);

      }else{
        this.responseMessage = "Please select primary owner and secondary owner to assign";
          this.successModal.show();
          setTimeout(() => {
            this.LoaderComponent = '';
            this.successModal.hide();
          }, 4000);
      }
    } else {
      if(primaryOwner != null  && primaryOwner.length>0){
        this.responseMessage = "";
         if(primaryOwner && secondaryOwner?.length > 0 &&  parseInt(primaryOwner[0]['id'])===parseInt(secondaryOwner[0]['id']) || selectedPrimaryOwner && parseInt(selectedPrimaryOwner)=== secondaryOwner && parseInt(secondaryOwner[0]['id']) ||selectedSecondaryOwner && primaryOwner && parseInt(selectedSecondaryOwner) ===parseInt(primaryOwner[0]['id'])){
          this.responseMessage = "Both Primary Owner and Secondary Owner should not be same";
          this.successModal.show();
          setTimeout(() => {
            this.LoaderComponent = '';
            this.successModal.hide();
          }, 5000);
        }
        else if(primaryOwner?.length > 0 && secondaryOwner?.length > 0) {
          let RM1Branch = primaryOwner?.[0].name.substring(primaryOwner?.[0].name.indexOf('(') + 1 , primaryOwner?.[0].name.indexOf('(') + 3)
          let RM2Branch = secondaryOwner?.[0].name.substring(secondaryOwner?.[0].name.indexOf('(') + 1 , secondaryOwner?.[0].name.indexOf('(') + 3)
          if(RM1Branch === RM2Branch) {
            if(primaryOwner?.[0].isManagement != true && secondaryOwner?.[0].isManagement != true) {
              this.responseMessage = "Cannot Assign Primary Owner and Secondary Owner from same Branch";
              this.successModal.show();
              setTimeout(() => {
                this.LoaderComponent = '';
                this.successModal.hide();
              }, 5000);
            }
            else{
              let profileObject = { profileId: profileId, cust_id: eachProfile['cust_id'], TicketID: ticketId, profileType: profileType, profileOwner: primaryOwner, secondaryOwner: secondaryOwner,SelectedProfileOwner:selectedPrimaryOwner,SelectedProfileSecondaryOwner: selectedSecondaryOwner, ExclusiveGrade: exclusiveGrade}
              this.assignedOwner.emit(profileObject)
            }
          }
          else {
            let profileObject = { profileId: profileId, cust_id: eachProfile['cust_id'], TicketID: ticketId, profileType: profileType, profileOwner: primaryOwner, secondaryOwner: secondaryOwner,SelectedProfileOwner:selectedPrimaryOwner,SelectedProfileSecondaryOwner: selectedSecondaryOwner, ExclusiveGrade: exclusiveGrade}
            this.assignedOwner.emit(profileObject)
          }
        }
        else{
          if(profileType && profileType[0]['id'] !== 604 && exclusiveGrade){
            this.responseMessage = `Cannot Assign Exclusive Category to ${profileType[0]['name']} Profile Type`;
            this.successModal.show();
            return
          }
          let profileObject = { profileId: profileId, cust_id: eachProfile['cust_id'], TicketID: ticketId, profileType: profileType, profileOwner: primaryOwner, secondaryOwner: secondaryOwner,SelectedProfileOwner:selectedPrimaryOwner,SelectedProfileSecondaryOwner: selectedSecondaryOwner,ExclusiveGrade: exclusiveGrade}
          this.assignedOwner.emit(profileObject)

        }

      }else{
        this.responseMessage = "Please select primary owner to assign";
          this.successModal.show();
          setTimeout(() => {
            this.LoaderComponent = '';
            this.successModal.hide();
          }, 4000);
      }
    }

  }

  findDuplicate(profileId) {
    this.findDuplicateProfiles.emit(profileId)
    this.selectedProfileColor ="#337ab7"
    this.selectedIndex = profileId
  }


  ngOnChange() {
  }

  editedByAdmin(profileId, agreedAmount, paidAmount, description) {
    if (agreedAmount != null && paidAmount != null) {
      this.adminForm.patchValue({
        agreedAmount: agreedAmount,
        paidAmount: paidAmount,
        paydescription: description
      })
      this.balanceAmount = paidAmount!=null?(agreedAmount-paidAmount):agreedAmount

    }
    this.adminModal.show();

  }



  omit_specialChar_and_char(event) {
    let x = event.which || event.keycode;
    if ((x >= 48 && x <= 57))
      return true;
    else
      return false;
  }

  submitAdminForm() {
    if (!this.adminForm.valid) {
      return
    } else {
      this.adminModal.hide();
      this.adminForm.value['empid'] = this.loginData['employeeID'];
      this.adminForm.value['paymentID'] = this.formValue['paymentID'];
      this.adminForm.value['paymentHistoryID'] = this.formValue['paymentHist_ID'];
      this.adminForm.value['profileID'] = this.formValue['profileID'];
      this.service.saveAdminEditForm(this.adminForm.value).then((response) => {
        this.LoaderComponent = LoaderComponent
        if (response['statusCode'] === 200) {
          this.LoaderComponent = '';
          this.responseMessage = response['message'];
          this.successModal.show();
          setTimeout(() => {
            this.LoaderComponent = '';
            this.successModal.hide();
          }, 5000);
        }
      })
    }

  }

  showPointsModal(expiryDate,formData){
    this.adminProfileId ="";
    this.updatePointsForm.reset();
    this.adminProfileId = this.getAdminProfileId('profileID',formData)
    this.isUpdatedPointsValue = false;
      this.paymentExpiryDate=expiryDate;
      this.updatePointsModal.show();
  }

  submitPointsForm(){
    if(this.updatePointsForm.value['extendedDays']===null && this.updatePointsForm.value['exetendedPoints']===null){
     this.isUpdatedPointsValue = true
      return true
    }else{
      this.isUpdatedPointsValue = false
      let savePaymentPoints={
        empID:this.loginData['employeeID'],
        cust_Id:this.formValue['custId'],
        profileId:this.formValue['profileID'],
        allowed_Days:this.updatePointsForm.value['extendedDays'],
        allowed_Points:this.updatePointsForm.value['exetendedPoints'],
        old_ExpiryDate:this.paymentExpiryDate
      }
      this.service.savePaymentPoints(savePaymentPoints).then((response)=>{
        this.LoaderComponent = LoaderComponent
        if (response['statusCode'] === 200) {
          this.updatePointsModal.hide();
          this.LoaderComponent = '';
          this.responseMessage = response['message'];
          this.updatePointsTable.emit(true)
          this.successModal.show();
          setTimeout(() => {
            this.LoaderComponent = '';
            this.successModal.hide();
          }, 5000);
        }
      })
    }

  }

  changeRowColour(element){
   if(element=== '393' || element==='57'){
     return '#17F067';
   } else if(element=== '394' || element==='56'){
      return '#BCC3BE';
   } else if(element==='55'){
     return '#185615'
   }
  }
  changeRowColourEditView(element,ticket,followUp, isLiving){
    if(element===57 || element===393 || element==='57' || element==='393'){
      return '#17F067';
    } else if(element===56 || element==='56' || element === '394' || element === 394){
       return '#BCC3BE';
    } else if(element===55 || element===395 || element==='55' || element==='395'){
      return '#185615'
    } else if (element === 604) {
      return '#FA8072'
    }
     if(ticket === 258){
      return '#C8E6E6'
    }
    if (followUp === 0 || isLiving) {
      return '#ecb1bc';
    }
  }

  changeRowColourSearchView(element, expire) {
    if (element === 604) {
      return '#FA8072'
    }

    if (expire === 1){
      return '#ecb1bc';
    }
  }

  changeRowColourEditViewValue(element){

    if(element && element===57 || element==='57' || element===393 || element==='393'){
      return '#17F067';
    } else if(element && element===56 || element==='56' || element===394 || element==='394'){
       return '#BCC3BE';
    } else if(element && element===55 || element==='55'){
      return '#185615'
    } else if(element && element===1 || element==='1'){
      return '#FF4500'
    }

  }
  reactivateProfile(profileGrade,custID,profileID) {

    if(profileID.length>9){
      this.reactivateProfileID = profileID.toString().substring(0, profileID.toString().indexOf('-') - 1)
    }else{
      this.reactivateProfileID = profileID
    }

    // console.log(profileGrade,custID,this.reactivateProfileID,profileID)
    let object = {
      "intCusID": String(custID),
      "profilid": this.reactivateProfileID,
      "empID": this.loginData['employeeID'],
      "admin": null,
      "currentprofilestatusid": 54,
      "profilegrade": profileGrade,
      "noofDaysinactivated": null,
      "reason4InActive": null,
      "requestedBy": null,
      "typeofReport": "ProfileSettings",
      "profileDisplayName": "",
      "loginStatusName": "",
      "blockedreason": ""
    }
    // console.log(object)
    this.service.saveProfileSettingObject(object).then((response) => {

      if (response['statusCode'] === 200) {
this.responseMessage = "Profile Activated Successfully"
this.successModal.show();
        setTimeout(()=>{
          this.successModal.hide()
        },4000)
      }
    })

  }
  selectedSettlementType(custId,type, element?: any){
    this.selectedStatusType.emit({custId:custId,type:type, element: element})
  }
  getOwnerDetails(ownerId){
    this.selectedOwner.emit({ownerId:ownerId})
  }
  getSecondaryOwnerDetails(ownerId){
    this.selectedSecondOwner.emit({ownerId:ownerId})
  }

  openPlayButton(id){
    const _id = id.replace(/[^\d]/g, '');
    this.openPlayButtonMode.emit(_id);
  }
  openCallRecording(url){
    this.playRecording.emit(url)
  }

  playSlideShow(){
    let value = "";
    this.playSlider.emit(value);
  }



  openCommunicationTicket(values, toticket?){
    const typeTicket = {existedTicketType : toticket}
    toticket != null ? Object.assign(values, typeTicket) : values;
    this.openMatchFollowupTicket.emit(values);
  }

  createTicket(values, toticket?) {
    const typeTicket = {ticketType : toticket}
    toticket != null ? Object.assign(values, typeTicket) : values;
    this.openMatchFollowupTicket.emit(values);
  }

  sendComEmail(element){
    if(element['fromEmail']!=null){
      this.LoaderComponent = LoaderComponent

      this.service.sendEmailForCommunicationLog(element['fromCustID'],element['fromEmail']).then((response)=>{
        if (response['statusCode'] === 200) {
          this.updatePointsModal.hide();
          this.LoaderComponent = '';
          this.responseMessage = response['message'];
          this.successModal.show();
          setTimeout(() => {
            this.LoaderComponent = '';
            this.successModal.hide();
          }, 5000);
        } else{
          this.LoaderComponent = '';
        }
      })

    }
  }

  resendComEmail(element, rvrFlag){
    this.resendComMail.emit({element, rvrFlag})
  }

  navigateToEditViewEducation(profileId){
      this.router.navigate([`/editViewDashBoard`,{id: profileId,type:'educational'}]);

  }

  navigateToServiceLog(profileId) {
    window.open(`/communicationLog;id=${profileId}`, '_blank');
  }

  viewSAFormWithPath(path){
    this.saFormPhotoPath = "";
    setTimeout(()=>{
      this.saFormPhotoPath = path;
    },10)

  }

  openAuthrization(object,type){
    this.authorize.emit({content:object,type:type})
  }


  isAmountValid(event){
    if(event.target.value){
      if(parseInt(event.target.value) > this.adminForm.value['agreedAmount'] ){
        this.isGreaterAmount = false;
        this.isValidAmount = true;
      }  else{
        this.isValidAmount = false;
        this.isGreaterAmount = false;
      }
    }
  }

  updateDeleteOffice(element,type){
    this.updateActions.emit({element:element,type:type})
  }

  profilesSelected(event) {
    if (event.isLowPriority) {
      var index = this.addedProfilesList.indexOf(event);
      if (index === -1) {
        this.addedProfilesList.push(event);
      } else {
        this.addedProfilesList.splice(index, 1);
      }
    } else if(!event.isLowPriority) {
      var index = this.addtoPriorityProfilesList.indexOf(event);
      if (index === -1) {
        this.addtoPriorityProfilesList.push(event);
        // console.log(this.addtoPriorityProfilesList);
      } else {
        this.addtoPriorityProfilesList.splice(index, 1);
      }
      // this.addedProfilesList.splice(index, 1);
      // console.log(this.addedProfilesList, 'fda');
    }
  }

  onSubmitMailPreference() {
    if(this.addedProfilesList.length) {
      const custIds = this.addedProfilesList.map(profile => profile.cust_ID)
      const priorityProfileObj = {
        toCustIDs: String(custIds),
        fromCustID: this.suitableEveObj['custID'],
        loginEmpID: this.suitableEveObj['empID'],
        flag: 71
      }
      this.submitPriorityProfileAsync(priorityProfileObj);
    } else if(this.addtoPriorityProfilesList.length) {
      const custIds = this.addtoPriorityProfilesList.map(profile => profile.cust_ID)
      const priorityProfileObj = {
        toCustIDs: String(custIds),
        fromCustID: this.suitableEveObj['custID'],
        loginEmpID: this.suitableEveObj['empID'],
        flag: 70
      }
      this.submitPriorityProfileAsync(priorityProfileObj);
    } else {
      const custIds = this.data.map(profile => profile.cust_ID)
      const priorityProfileObj = {
        toCustIDs: String(custIds),
        fromCustID: this.suitableEveObj['custID'],
        loginEmpID: this.suitableEveObj['empID'],
        flag: 70
      }
      this.submitPriorityProfileAsync(priorityProfileObj);
    }
  }

  submitPriorityProfileAsync(priorityProfileObj) {
    this.LoaderComponent = LoaderComponent;
    this.service.saveAutoMailProfilePriorityAsync(priorityProfileObj).then((response) => {
      if (response['statusCode'] === 200){
        this.responseMessage = this.addedProfilesList.length ? `Successfully submitted ${this.addedProfilesList.length} profiles` : `Successfully submitted ${this.addtoPriorityProfilesList.length} profiles`;
        this.LoaderComponent = "";
        this.addedProfilesList = [];
        this.addtoPriorityProfilesList = [];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
          this.navigateToBack();
        }, 2000);
      } else {
        this.LoaderComponent = "";
      }
    })
  }
  getDataBasedOnServiceType(obj){
    // console.log(this.profileOwnerArray.length)
      // if(this.profileOwnerArray.length <= 0){
        if(obj[0].id === 601 || obj[0].id === 602){
          this.service.loadMasterDataWithId('ProfileOwnerByGrade', null).then((res)=>{
            if(res['statusCode']=== 200){
              // this.profileOwnerArray = res['result']
              const updatedObj = res['result'].map(({
                value: name,
                ...rest
              }) => ({
                name,
                ...rest
              }));
              // console.log(updatedObj)
              this.profileOwnerArray = [];
              this.profileOwnerArray = updatedObj
            }
          })
        } else {
          this.service.loadMasterDataWithId('ProfileOwnerByGrade', obj[0].id).then((res)=>{
            if(res['statusCode']=== 200){
              // this.profileOwnerArray = res['result']
              const updatedObj = res['result'].map(({
                value: name,
                ...rest
              }) => ({
                name,
                ...rest
              }));
              // console.log(updatedObj)
              this.profileOwnerArray = [];
              this.profileOwnerArray = updatedObj
            }
          })
        }
      // }
}

  changeProfileType(event, profile) {
    // console.log(event)
    this.profileOwnerArray = [];
    if(event.id === 216 || event.id === 217|| event.id === 218 ||event.id === 219) {
      const obj = this.data.findIndex((ob => ob['ProfileID'] == profile['ProfileID']));
      this.data[obj]['ProfileOwnerID'] = [{id: 223, name: "Naveena yalamanchi(MS014)", isManagement: true}];
      this.data[obj]['ProfileSecondaryOwnerID'] = null;
      this.data[obj]['setDefaultProfileOwner'] = true;
      this.data[obj]['enableExclusiveGrade'] = false;
      this.data[obj]['exclusiveGrade'] = false
    } else if(event.name === 'Super Confidential'){
      const obj = this.data.findIndex((ob => ob['ProfileID'] == profile['ProfileID']));
      this.data[obj]['ProfileOwnerID'] = [{id: 223, name: "Naveena yalamanchi(MS014)", isManagement: true}];
      this.data[obj]['ProfileSecondaryOwnerID'] = null;
      this.data[obj]['setDefaultProfileOwner'] = true;
      this.data[obj]['enableExclusiveGrade'] = true;
      this.data[obj]['exclusiveGrade'] = true
    } else {
      const obj = this.data.findIndex((ob => ob['ProfileID'] == profile['ProfileID']));
      this.data[obj]['ProfileOwnerID'] = null;
      this.data[obj]['ProfileSecondaryOwnerID'] = null;
      this.data[obj]['setDefaultProfileOwner'] = false;
      this.data[obj]['enableExclusiveGrade'] = false;
      this.data[obj]['exclusiveGrade'] = false
    }
  }

  deselectProfileType(event, profile) {
    const obj = this.data.findIndex((ob => ob['ProfileID'] == profile['ProfileID']));
    this.data[obj]['ProfileOwnerID'] = null;
    this.profileOwnerArray=[];
  }

  enableBranchIPToUpdate(branchDetails) {
    // console.log(branchDetails);
    const obj  = this.data.findIndex((obj => obj['branchID'] == branchDetails['branchID']));
    this.data[obj]['branchUpdateMode'] = true;
  }

  updateBranchIP(branchDetails) {
    const data = {
      branchID: branchDetails['branchID'],
      ipaddress1: branchDetails['macAddressName'].trim(),
      ipaddress2: branchDetails['macAddressName_1'].trim()
    }
    this.LoaderComponent = LoaderComponent;
    this.service.updateBranchIP(data).then((response) => {
      if(response['statusCode'] === 200) {
        const trackingActivityData = {
          Application: 'E',
          RoleId: this.loginData['empTypeID'],
          Event: 'Update Branch IP',
          Module: 'Admin forms',
          EventOutcomeIndicator: `Updated branch IP of branch ${branchDetails['branchName']}`,
          IPAddress: this.loginData.ipAddress
        };
        this.service.getActivityTracking(trackingActivityData).then((res) => {
          // console.log(res);
        });
        this.LoaderComponent = '';
        this.responseMessage = 'Branch IP Updated Successfully';
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 3000);
        const obj  = this.data.findIndex((obj => obj['branchID'] == branchDetails['branchID']));
        this.data[obj]['branchUpdateMode'] = false;
      } else {
        this.responseMessage = response['message'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 3000);
      }
    })
  }

  editBroker(broker) {
    const dialogRef = this.dialog.open(BrokerCreateDialogComponent, {
      width: '1000px',
      data: {broker}
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.loadBrokerList.emit(true);
      }
    })
  }

  deleteBroker(element) {
    this.brokerDetail = element;
    this.brokerModal.show();
  }

  deleteBrokerDetails() {
    this.LoaderComponent = LoaderComponent;
    this.service.deleteBroker(this.brokerDetail.id).then((res) => {
      if(res['statusCode'] === 200) {
        this.LoaderComponent = '';
        this.brokerModal.hide();
        this.responseMessage = 'Broker Deleted Successfully';
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
          this.loadBrokerList.emit(true);
        }, 2000);
      }
    })
  }

  updateCustomerLeftIndia(element) {
    const dialogRef = this.dialog.open(CustomerLeftUpdateDialogComponent, {
      width: '850px',
      data: element
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.reloadCustomersList.emit(true);
      }
    });
  }

  openMarketingTkt(element) {
    // console.log(element);
    this.modalBoolean = true;
    this.ticketId = element['ticketID']
  }

  openFoneFormat(row) {
    const obj = {
      fromCustID: row.fromCustID,
      toCustID: row.toCustID,
      formatType: 1,
      viewType: 1,
      printReason: null
    };
    this.LoaderComponent = LoaderComponent;
    this.service.updateEmpViewFormatAsync(obj).then((res) => {
      if (res['statusCode'] === 200) {
        this.LoaderComponent = '';
        window.open(`/viewProfile;profileID=${row.profileID};format=1;fromCustID=${row.fromCustID};toCustID=${row.toCustID};pageID=4;`, '_blank');
      }
    })
  }

  openFtwoFormat(row) {
    const obj = {
      fromCustID: row.fromCustID,
      toCustID: row.toCustID,
      formatType: 2,
      viewType: 1,
      printReason: null
    };
    this.LoaderComponent = LoaderComponent;
    this.service.updateEmpViewFormatAsync(obj).then((res) => {
      if (res['statusCode'] === 200) {
        this.LoaderComponent = '';
        window.open(`/viewProfile;profileID=${row.profileID};format=2;fromCustID=${row.fromCustID};toCustID=${row.toCustID};pageID=4;`, '_blank');
      }
    })
  }

  openFthreeFormat(row) {
    const obj = {
      fromCustID: row.fromCustID,
      toCustID: row.toCustID,
      formatType: 3,
      viewType: 1,
      printReason: null
    };
    this.LoaderComponent = LoaderComponent;
    this.service.updateEmpViewFormatAsync(obj).then((res) => {
      if (res['statusCode'] === 200) {
        this.LoaderComponent = "";
        window.open(`/viewProfile;profileID=${row.profileID};format=3;fromCustID=${row.fromCustID};toCustID=${row.toCustID};pageID=4`, '_blank');
      }
    })
  }

  openFfourFormat(row) {
    const obj = {
      fromCustID: row.fromCustID,
      toCustID: row.toCustID,
      formatType: 4,
      viewType: 1,
      printReason: null
    };
    this.LoaderComponent = LoaderComponent;
    this.service.updateEmpViewFormatAsync(obj).then((res) => {
      if (res['statusCode'] === 200) {
        this.LoaderComponent = "";
        window.open(`/viewProfile;profileID=${row.profileID};format=4;fromCustID=${row.fromCustID};toCustID=${row.toCustID};pageID=4`, '_blank');
      }
    })
  }

  getFormatHistory(profile) {
    const obj = {
      toCustID: profile.toCustID,
      isGetResponse: true
    };
    this.LoaderComponent = LoaderComponent;
    this.service.updateEmpViewFormatAsync(obj).then((res) => {
      if (res['statusCode'] === 200) {
        this.LoaderComponent = "";
        const dialogRef = this.dialog.open(FormatHistoryComponent, {
          width: '650px',
          data: res['result']
        })
      }
    });
  }

  printMarketingValues(){
    this.data.forEach(element => {
      // console.log(element.lastName)
      this.dataToPrint.push(
        {
          printData : element.printLabelData,
          custID: element.cust_ID,
          address: this.printAddress,
          profileID: element.profileID,
          Type: 1
        }
        )
    });


    // console.log(this.dataToPrint)
    this.service.sendData(this.dataToPrint)
    // this.router.navigate([`/viewProfile`])

    const dialogRef = this.dialog.open(ReasonDialogComponent, {
      disableClose: true,
      width: '95%',
      maxWidth: '95%',
      height: '92%',
      data: {}
    });


  }
   printMarketingValuesAdv(){
    this.dataToGrid.forEach(element => {
      this.dataToPrint.push(
        {
          printData : element.advancePrintData,
          address: this.printAdvAddress,
          custID: element.cust_ID,
          profileID: element.profileID,
          Type: 2
        }
        )
    });
    this.service.sendData(this.dataToPrint);
    const dialogRef = this.dialog.open(ReasonDialogComponent, {
      disableClose: true,
      width: '95%',
      maxWidth: '95%',
      height: '92%',
      data:{}
    });
    dialogRef.afterClosed().subscribe(result => {
      this.dataToPrint = [];
    });
  }



  _convertDate(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    month.length < 2 ? (month = '0' + month) : month;
    day.length < 2 ? (day = '0' + day) : month;

    return [day, month, year].join('-');
  }
}
